// Desktop header: the menu row (.header__bot) slides away when scrolling down and
// comes back when scrolling up. Styles: "Header menu row: hide on scroll" in custom_css.css.
//
// The row is taken out of the page flow and slides under the sticky header with a
// transform, so hiding and showing it never changes the page height and the content
// never jumps. A margin of the same height under the header keeps the space for it at
// the top of the page.
(function () {
  'use strict';

  var header = document.getElementById('shopify-section-header_new');
  if (!header) return;
  var menuRow = header.querySelector('.header__bot');
  if (!menuRow) return;

  var DESKTOP = window.matchMedia('(min-width: 769px)');
  var SHOW_NEAR_TOP = 10;   // px from the top where the menu is always shown
  var MIN_MOVE = 6;         // ignore smaller scroll changes (trackpad jitter)

  var lastY = window.pageYOffset;
  var hidden = false;

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    header.classList.toggle('lb-menu-hidden', hidden);
  }

  // Space reserved below the header for the menu row, and the distance to scroll
  // before hiding is allowed (so it never hides while still visible in the page top).
  function measure() {
    var h = DESKTOP.matches ? menuRow.getBoundingClientRect().height : 0;
    header.style.setProperty('--lb-menu-row-h', h + 'px');
  }

  function menuInUse() {
    // Keep it open while a dropdown is open or a menu link has keyboard focus.
    return menuRow.matches(':hover') || menuRow.contains(document.activeElement);
  }

  function onScroll() {
    var y = Math.max(0, window.pageYOffset);
    if (!DESKTOP.matches || y <= SHOW_NEAR_TOP) {
      setHidden(false);
      lastY = y;
      return;
    }
    var delta = y - lastY;
    if (Math.abs(delta) < MIN_MOVE) return;
    if (delta > 0 && y > menuRow.offsetHeight + header.offsetHeight) {
      if (!menuInUse()) setHidden(true);
    } else if (delta < 0) {
      setHidden(false);
    }
    lastY = y;
  }

  header.classList.add('lb-menu-row-ready');
  measure();
  onScroll();

  window.addEventListener('scroll', onScroll, {passive: true});
  window.addEventListener('resize', function () {
    measure();
    onScroll();
  });
  if (DESKTOP.addEventListener) {
    DESKTOP.addEventListener('change', function () {
      measure();
      setHidden(false);
    });
  }
  // Fonts or the logo can change the row height after load.
  window.addEventListener('load', measure);
  // The row can be hidden (0px) while the theme's styles are still loading, so re-measure
  // whenever its size changes; otherwise the page content slides up under the menu.
  if (window.ResizeObserver) {
    new ResizeObserver(measure).observe(menuRow);
  }
  // Moving the mouse to the top edge of the window brings the menu back.
  document.addEventListener('mousemove', function (event) {
    if (hidden && event.clientY < header.offsetHeight) setHidden(false);
  }, {passive: true});
})();
